/* tslint:disable */
/* eslint-disable */
/**
 * ElisTech API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.0
 * Contact: info@ideatech.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiV1SurveyExportSettingsAttachmentsAttachmentIdDelete200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest } from '../models';
// @ts-ignore
import type { ApiV1SurveySettingsAttachmentsSurveyUuidGet200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveySettingsGeneralSurveyUuidGet200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveySettingsGeneralSurveyUuidPatchRequest } from '../models';
/**
 * PerSurveyExportSettingsApi - axios parameter creator
 */
export const PerSurveyExportSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes attachment. Clones global settings on first edit.
         * @summary Delete attachment from survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {string} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdDelete: async (surveyUuid: string, attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyUuid' is not null or undefined
            assertParamExists('apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdDelete', 'surveyUuid', surveyUuid)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdDelete', 'attachmentId', attachmentId)
            const localVarPath = `/api/v1/survey-settings/attachments/{surveyUuid}/{attachmentId}`
                .replace('{surveyUuid}', encodeURIComponent(String(surveyUuid)))
                .replace('{attachmentId}', encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes attachment. Clones global settings on first edit.
         * @summary Delete attachment from survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {string} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdDelete_1: async (surveyUuid: string, attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyUuid' is not null or undefined
            assertParamExists('apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdDelete_1', 'surveyUuid', surveyUuid)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdDelete_1', 'attachmentId', attachmentId)
            const localVarPath = `/api/v1/survey-settings/attachments/{surveyUuid}/{attachmentId}`
                .replace('{surveyUuid}', encodeURIComponent(String(surveyUuid)))
                .replace('{attachmentId}', encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates attachment. Clones global settings on first edit.
         * @summary Update attachment title and active status for survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {string} attachmentId Attachment ID
         * @param {ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest} apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdPatch: async (surveyUuid: string, attachmentId: string, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest: ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyUuid' is not null or undefined
            assertParamExists('apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdPatch', 'surveyUuid', surveyUuid)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdPatch', 'attachmentId', attachmentId)
            // verify required parameter 'apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest' is not null or undefined
            assertParamExists('apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdPatch', 'apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest', apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest)
            const localVarPath = `/api/v1/survey-settings/attachments/{surveyUuid}/{attachmentId}`
                .replace('{surveyUuid}', encodeURIComponent(String(surveyUuid)))
                .replace('{attachmentId}', encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates attachment. Clones global settings on first edit.
         * @summary Update attachment title and active status for survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {string} attachmentId Attachment ID
         * @param {ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest} apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdPatch_2: async (surveyUuid: string, attachmentId: string, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest: ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyUuid' is not null or undefined
            assertParamExists('apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdPatch_2', 'surveyUuid', surveyUuid)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdPatch_2', 'attachmentId', attachmentId)
            // verify required parameter 'apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest' is not null or undefined
            assertParamExists('apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdPatch_2', 'apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest', apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest)
            const localVarPath = `/api/v1/survey-settings/attachments/{surveyUuid}/{attachmentId}`
                .replace('{surveyUuid}', encodeURIComponent(String(surveyUuid)))
                .replace('{attachmentId}', encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns attachments for survey. Uses global settings if no custom version exists.
         * @summary Get all attachments for survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsAttachmentsSurveyUuidGet: async (surveyUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyUuid' is not null or undefined
            assertParamExists('apiV1SurveySettingsAttachmentsSurveyUuidGet', 'surveyUuid', surveyUuid)
            const localVarPath = `/api/v1/survey-settings/attachments/{surveyUuid}`
                .replace('{surveyUuid}', encodeURIComponent(String(surveyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns attachments for survey. Uses global settings if no custom version exists.
         * @summary Get all attachments for survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsAttachmentsSurveyUuidGet_3: async (surveyUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyUuid' is not null or undefined
            assertParamExists('apiV1SurveySettingsAttachmentsSurveyUuidGet_3', 'surveyUuid', surveyUuid)
            const localVarPath = `/api/v1/survey-settings/attachments/{surveyUuid}`
                .replace('{surveyUuid}', encodeURIComponent(String(surveyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploads attachment. Clones global settings on first edit.
         * @summary Upload new attachment for survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {File} attachment Attachment file
         * @param {string} [title] Optional title for the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsAttachmentsSurveyUuidPost: async (surveyUuid: string, attachment: File, title?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyUuid' is not null or undefined
            assertParamExists('apiV1SurveySettingsAttachmentsSurveyUuidPost', 'surveyUuid', surveyUuid)
            // verify required parameter 'attachment' is not null or undefined
            assertParamExists('apiV1SurveySettingsAttachmentsSurveyUuidPost', 'attachment', attachment)
            const localVarPath = `/api/v1/survey-settings/attachments/{surveyUuid}`
                .replace('{surveyUuid}', encodeURIComponent(String(surveyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (attachment !== undefined) { 
                localVarFormParams.append('attachment', attachment as any);
            }

            if (title !== undefined) { 
                localVarFormParams.append('title', title as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploads attachment. Clones global settings on first edit.
         * @summary Upload new attachment for survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {File} attachment Attachment file
         * @param {string} [title] Optional title for the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsAttachmentsSurveyUuidPost_4: async (surveyUuid: string, attachment: File, title?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyUuid' is not null or undefined
            assertParamExists('apiV1SurveySettingsAttachmentsSurveyUuidPost_4', 'surveyUuid', surveyUuid)
            // verify required parameter 'attachment' is not null or undefined
            assertParamExists('apiV1SurveySettingsAttachmentsSurveyUuidPost_4', 'attachment', attachment)
            const localVarPath = `/api/v1/survey-settings/attachments/{surveyUuid}`
                .replace('{surveyUuid}', encodeURIComponent(String(surveyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (attachment !== undefined) { 
                localVarFormParams.append('attachment', attachment as any);
            }

            if (title !== undefined) { 
                localVarFormParams.append('title', title as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns survey export settings. Uses global settings if no custom version exists.
         * @summary Get survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsGeneralSurveyUuidGet: async (surveyUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyUuid' is not null or undefined
            assertParamExists('apiV1SurveySettingsGeneralSurveyUuidGet', 'surveyUuid', surveyUuid)
            const localVarPath = `/api/v1/survey-settings/general/{surveyUuid}`
                .replace('{surveyUuid}', encodeURIComponent(String(surveyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns survey export settings. Uses global settings if no custom version exists.
         * @summary Get survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsGeneralSurveyUuidGet_5: async (surveyUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyUuid' is not null or undefined
            assertParamExists('apiV1SurveySettingsGeneralSurveyUuidGet_5', 'surveyUuid', surveyUuid)
            const localVarPath = `/api/v1/survey-settings/general/{surveyUuid}`
                .replace('{surveyUuid}', encodeURIComponent(String(surveyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates survey export settings. Clones global settings on first edit. The reportLanguage field is a per-survey override stored on the survey itself: null = leave unchanged, empty string = clear the override back to inherit, non-empty = set the override. When the PATCH changes the effective report language and the survey already has its own cloned version, its six report text fields are automatically reset to the owner global baseline for the new language (text values sent in the same PATCH win). A survey still sharing the global version is NOT cloned by a language-only PATCH — it keeps following global settings and its texts switch language automatically via the global per-language rows.
         * @summary Update survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {ApiV1SurveySettingsGeneralSurveyUuidPatchRequest} [apiV1SurveySettingsGeneralSurveyUuidPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsGeneralSurveyUuidPatch: async (surveyUuid: string, apiV1SurveySettingsGeneralSurveyUuidPatchRequest?: ApiV1SurveySettingsGeneralSurveyUuidPatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyUuid' is not null or undefined
            assertParamExists('apiV1SurveySettingsGeneralSurveyUuidPatch', 'surveyUuid', surveyUuid)
            const localVarPath = `/api/v1/survey-settings/general/{surveyUuid}`
                .replace('{surveyUuid}', encodeURIComponent(String(surveyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1SurveySettingsGeneralSurveyUuidPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates survey export settings. Clones global settings on first edit. The reportLanguage field is a per-survey override stored on the survey itself: null = leave unchanged, empty string = clear the override back to inherit, non-empty = set the override. When the PATCH changes the effective report language and the survey already has its own cloned version, its six report text fields are automatically reset to the owner global baseline for the new language (text values sent in the same PATCH win). A survey still sharing the global version is NOT cloned by a language-only PATCH — it keeps following global settings and its texts switch language automatically via the global per-language rows.
         * @summary Update survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {ApiV1SurveySettingsGeneralSurveyUuidPatchRequest} [apiV1SurveySettingsGeneralSurveyUuidPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsGeneralSurveyUuidPatch_6: async (surveyUuid: string, apiV1SurveySettingsGeneralSurveyUuidPatchRequest?: ApiV1SurveySettingsGeneralSurveyUuidPatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyUuid' is not null or undefined
            assertParamExists('apiV1SurveySettingsGeneralSurveyUuidPatch_6', 'surveyUuid', surveyUuid)
            const localVarPath = `/api/v1/survey-settings/general/{surveyUuid}`
                .replace('{surveyUuid}', encodeURIComponent(String(surveyUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1SurveySettingsGeneralSurveyUuidPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PerSurveyExportSettingsApi - functional programming interface
 */
export const PerSurveyExportSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PerSurveyExportSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes attachment. Clones global settings on first edit.
         * @summary Delete attachment from survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {string} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdDelete(surveyUuid: string, attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdDelete(surveyUuid, attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PerSurveyExportSettingsApi.apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes attachment. Clones global settings on first edit.
         * @summary Delete attachment from survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {string} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdDelete_1(surveyUuid: string, attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdDelete_1(surveyUuid, attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PerSurveyExportSettingsApi.apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdDelete_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates attachment. Clones global settings on first edit.
         * @summary Update attachment title and active status for survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {string} attachmentId Attachment ID
         * @param {ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest} apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdPatch(surveyUuid: string, attachmentId: string, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest: ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdPatch(surveyUuid, attachmentId, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PerSurveyExportSettingsApi.apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates attachment. Clones global settings on first edit.
         * @summary Update attachment title and active status for survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {string} attachmentId Attachment ID
         * @param {ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest} apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdPatch_2(surveyUuid: string, attachmentId: string, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest: ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdPatch_2(surveyUuid, attachmentId, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PerSurveyExportSettingsApi.apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdPatch_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns attachments for survey. Uses global settings if no custom version exists.
         * @summary Get all attachments for survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveySettingsAttachmentsSurveyUuidGet(surveyUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveySettingsAttachmentsSurveyUuidGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveySettingsAttachmentsSurveyUuidGet(surveyUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PerSurveyExportSettingsApi.apiV1SurveySettingsAttachmentsSurveyUuidGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns attachments for survey. Uses global settings if no custom version exists.
         * @summary Get all attachments for survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveySettingsAttachmentsSurveyUuidGet_3(surveyUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveySettingsAttachmentsSurveyUuidGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveySettingsAttachmentsSurveyUuidGet_3(surveyUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PerSurveyExportSettingsApi.apiV1SurveySettingsAttachmentsSurveyUuidGet_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Uploads attachment. Clones global settings on first edit.
         * @summary Upload new attachment for survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {File} attachment Attachment file
         * @param {string} [title] Optional title for the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveySettingsAttachmentsSurveyUuidPost(surveyUuid: string, attachment: File, title?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveySettingsAttachmentsSurveyUuidPost(surveyUuid, attachment, title, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PerSurveyExportSettingsApi.apiV1SurveySettingsAttachmentsSurveyUuidPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Uploads attachment. Clones global settings on first edit.
         * @summary Upload new attachment for survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {File} attachment Attachment file
         * @param {string} [title] Optional title for the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveySettingsAttachmentsSurveyUuidPost_4(surveyUuid: string, attachment: File, title?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveySettingsAttachmentsSurveyUuidPost_4(surveyUuid, attachment, title, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PerSurveyExportSettingsApi.apiV1SurveySettingsAttachmentsSurveyUuidPost_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns survey export settings. Uses global settings if no custom version exists.
         * @summary Get survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveySettingsGeneralSurveyUuidGet(surveyUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveySettingsGeneralSurveyUuidGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveySettingsGeneralSurveyUuidGet(surveyUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PerSurveyExportSettingsApi.apiV1SurveySettingsGeneralSurveyUuidGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns survey export settings. Uses global settings if no custom version exists.
         * @summary Get survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveySettingsGeneralSurveyUuidGet_5(surveyUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveySettingsGeneralSurveyUuidGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveySettingsGeneralSurveyUuidGet_5(surveyUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PerSurveyExportSettingsApi.apiV1SurveySettingsGeneralSurveyUuidGet_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates survey export settings. Clones global settings on first edit. The reportLanguage field is a per-survey override stored on the survey itself: null = leave unchanged, empty string = clear the override back to inherit, non-empty = set the override. When the PATCH changes the effective report language and the survey already has its own cloned version, its six report text fields are automatically reset to the owner global baseline for the new language (text values sent in the same PATCH win). A survey still sharing the global version is NOT cloned by a language-only PATCH — it keeps following global settings and its texts switch language automatically via the global per-language rows.
         * @summary Update survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {ApiV1SurveySettingsGeneralSurveyUuidPatchRequest} [apiV1SurveySettingsGeneralSurveyUuidPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveySettingsGeneralSurveyUuidPatch(surveyUuid: string, apiV1SurveySettingsGeneralSurveyUuidPatchRequest?: ApiV1SurveySettingsGeneralSurveyUuidPatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveySettingsGeneralSurveyUuidGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveySettingsGeneralSurveyUuidPatch(surveyUuid, apiV1SurveySettingsGeneralSurveyUuidPatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PerSurveyExportSettingsApi.apiV1SurveySettingsGeneralSurveyUuidPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates survey export settings. Clones global settings on first edit. The reportLanguage field is a per-survey override stored on the survey itself: null = leave unchanged, empty string = clear the override back to inherit, non-empty = set the override. When the PATCH changes the effective report language and the survey already has its own cloned version, its six report text fields are automatically reset to the owner global baseline for the new language (text values sent in the same PATCH win). A survey still sharing the global version is NOT cloned by a language-only PATCH — it keeps following global settings and its texts switch language automatically via the global per-language rows.
         * @summary Update survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {ApiV1SurveySettingsGeneralSurveyUuidPatchRequest} [apiV1SurveySettingsGeneralSurveyUuidPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveySettingsGeneralSurveyUuidPatch_6(surveyUuid: string, apiV1SurveySettingsGeneralSurveyUuidPatchRequest?: ApiV1SurveySettingsGeneralSurveyUuidPatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveySettingsGeneralSurveyUuidGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveySettingsGeneralSurveyUuidPatch_6(surveyUuid, apiV1SurveySettingsGeneralSurveyUuidPatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PerSurveyExportSettingsApi.apiV1SurveySettingsGeneralSurveyUuidPatch_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PerSurveyExportSettingsApi - factory interface
 */
export const PerSurveyExportSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PerSurveyExportSettingsApiFp(configuration)
    return {
        /**
         * Deletes attachment. Clones global settings on first edit.
         * @summary Delete attachment from survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {string} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdDelete(surveyUuid: string, attachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdDelete200Response> {
            return localVarFp.apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdDelete(surveyUuid, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes attachment. Clones global settings on first edit.
         * @summary Delete attachment from survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {string} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdDelete_1(surveyUuid: string, attachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdDelete200Response> {
            return localVarFp.apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdDelete_1(surveyUuid, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates attachment. Clones global settings on first edit.
         * @summary Update attachment title and active status for survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {string} attachmentId Attachment ID
         * @param {ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest} apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdPatch(surveyUuid: string, attachmentId: string, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest: ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdPatch(surveyUuid, attachmentId, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates attachment. Clones global settings on first edit.
         * @summary Update attachment title and active status for survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {string} attachmentId Attachment ID
         * @param {ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest} apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdPatch_2(surveyUuid: string, attachmentId: string, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest: ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdPatch_2(surveyUuid, attachmentId, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns attachments for survey. Uses global settings if no custom version exists.
         * @summary Get all attachments for survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsAttachmentsSurveyUuidGet(surveyUuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveySettingsAttachmentsSurveyUuidGet200Response> {
            return localVarFp.apiV1SurveySettingsAttachmentsSurveyUuidGet(surveyUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns attachments for survey. Uses global settings if no custom version exists.
         * @summary Get all attachments for survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsAttachmentsSurveyUuidGet_3(surveyUuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveySettingsAttachmentsSurveyUuidGet200Response> {
            return localVarFp.apiV1SurveySettingsAttachmentsSurveyUuidGet_3(surveyUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads attachment. Clones global settings on first edit.
         * @summary Upload new attachment for survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {File} attachment Attachment file
         * @param {string} [title] Optional title for the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsAttachmentsSurveyUuidPost(surveyUuid: string, attachment: File, title?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveySettingsAttachmentsSurveyUuidPost(surveyUuid, attachment, title, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads attachment. Clones global settings on first edit.
         * @summary Upload new attachment for survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {File} attachment Attachment file
         * @param {string} [title] Optional title for the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsAttachmentsSurveyUuidPost_4(surveyUuid: string, attachment: File, title?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveySettingsAttachmentsSurveyUuidPost_4(surveyUuid, attachment, title, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns survey export settings. Uses global settings if no custom version exists.
         * @summary Get survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsGeneralSurveyUuidGet(surveyUuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveySettingsGeneralSurveyUuidGet200Response> {
            return localVarFp.apiV1SurveySettingsGeneralSurveyUuidGet(surveyUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns survey export settings. Uses global settings if no custom version exists.
         * @summary Get survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsGeneralSurveyUuidGet_5(surveyUuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveySettingsGeneralSurveyUuidGet200Response> {
            return localVarFp.apiV1SurveySettingsGeneralSurveyUuidGet_5(surveyUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates survey export settings. Clones global settings on first edit. The reportLanguage field is a per-survey override stored on the survey itself: null = leave unchanged, empty string = clear the override back to inherit, non-empty = set the override. When the PATCH changes the effective report language and the survey already has its own cloned version, its six report text fields are automatically reset to the owner global baseline for the new language (text values sent in the same PATCH win). A survey still sharing the global version is NOT cloned by a language-only PATCH — it keeps following global settings and its texts switch language automatically via the global per-language rows.
         * @summary Update survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {ApiV1SurveySettingsGeneralSurveyUuidPatchRequest} [apiV1SurveySettingsGeneralSurveyUuidPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsGeneralSurveyUuidPatch(surveyUuid: string, apiV1SurveySettingsGeneralSurveyUuidPatchRequest?: ApiV1SurveySettingsGeneralSurveyUuidPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveySettingsGeneralSurveyUuidGet200Response> {
            return localVarFp.apiV1SurveySettingsGeneralSurveyUuidPatch(surveyUuid, apiV1SurveySettingsGeneralSurveyUuidPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates survey export settings. Clones global settings on first edit. The reportLanguage field is a per-survey override stored on the survey itself: null = leave unchanged, empty string = clear the override back to inherit, non-empty = set the override. When the PATCH changes the effective report language and the survey already has its own cloned version, its six report text fields are automatically reset to the owner global baseline for the new language (text values sent in the same PATCH win). A survey still sharing the global version is NOT cloned by a language-only PATCH — it keeps following global settings and its texts switch language automatically via the global per-language rows.
         * @summary Update survey-specific export settings
         * @param {string} surveyUuid Survey UUID
         * @param {ApiV1SurveySettingsGeneralSurveyUuidPatchRequest} [apiV1SurveySettingsGeneralSurveyUuidPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveySettingsGeneralSurveyUuidPatch_6(surveyUuid: string, apiV1SurveySettingsGeneralSurveyUuidPatchRequest?: ApiV1SurveySettingsGeneralSurveyUuidPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveySettingsGeneralSurveyUuidGet200Response> {
            return localVarFp.apiV1SurveySettingsGeneralSurveyUuidPatch_6(surveyUuid, apiV1SurveySettingsGeneralSurveyUuidPatchRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PerSurveyExportSettingsApi - object-oriented interface
 */
export class PerSurveyExportSettingsApi extends BaseAPI {
    /**
     * Deletes attachment. Clones global settings on first edit.
     * @summary Delete attachment from survey-specific export settings
     * @param {string} surveyUuid Survey UUID
     * @param {string} attachmentId Attachment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdDelete(surveyUuid: string, attachmentId: string, options?: RawAxiosRequestConfig) {
        return PerSurveyExportSettingsApiFp(this.configuration).apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdDelete(surveyUuid, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes attachment. Clones global settings on first edit.
     * @summary Delete attachment from survey-specific export settings
     * @param {string} surveyUuid Survey UUID
     * @param {string} attachmentId Attachment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdDelete_1(surveyUuid: string, attachmentId: string, options?: RawAxiosRequestConfig) {
        return PerSurveyExportSettingsApiFp(this.configuration).apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdDelete_1(surveyUuid, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates attachment. Clones global settings on first edit.
     * @summary Update attachment title and active status for survey-specific export settings
     * @param {string} surveyUuid Survey UUID
     * @param {string} attachmentId Attachment ID
     * @param {ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest} apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdPatch(surveyUuid: string, attachmentId: string, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest: ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options?: RawAxiosRequestConfig) {
        return PerSurveyExportSettingsApiFp(this.configuration).apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdPatch(surveyUuid, attachmentId, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates attachment. Clones global settings on first edit.
     * @summary Update attachment title and active status for survey-specific export settings
     * @param {string} surveyUuid Survey UUID
     * @param {string} attachmentId Attachment ID
     * @param {ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest} apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdPatch_2(surveyUuid: string, attachmentId: string, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest: ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options?: RawAxiosRequestConfig) {
        return PerSurveyExportSettingsApiFp(this.configuration).apiV1SurveySettingsAttachmentsSurveyUuidAttachmentIdPatch_2(surveyUuid, attachmentId, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns attachments for survey. Uses global settings if no custom version exists.
     * @summary Get all attachments for survey-specific export settings
     * @param {string} surveyUuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveySettingsAttachmentsSurveyUuidGet(surveyUuid: string, options?: RawAxiosRequestConfig) {
        return PerSurveyExportSettingsApiFp(this.configuration).apiV1SurveySettingsAttachmentsSurveyUuidGet(surveyUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns attachments for survey. Uses global settings if no custom version exists.
     * @summary Get all attachments for survey-specific export settings
     * @param {string} surveyUuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveySettingsAttachmentsSurveyUuidGet_3(surveyUuid: string, options?: RawAxiosRequestConfig) {
        return PerSurveyExportSettingsApiFp(this.configuration).apiV1SurveySettingsAttachmentsSurveyUuidGet_3(surveyUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uploads attachment. Clones global settings on first edit.
     * @summary Upload new attachment for survey-specific export settings
     * @param {string} surveyUuid Survey UUID
     * @param {File} attachment Attachment file
     * @param {string} [title] Optional title for the attachment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveySettingsAttachmentsSurveyUuidPost(surveyUuid: string, attachment: File, title?: string, options?: RawAxiosRequestConfig) {
        return PerSurveyExportSettingsApiFp(this.configuration).apiV1SurveySettingsAttachmentsSurveyUuidPost(surveyUuid, attachment, title, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uploads attachment. Clones global settings on first edit.
     * @summary Upload new attachment for survey-specific export settings
     * @param {string} surveyUuid Survey UUID
     * @param {File} attachment Attachment file
     * @param {string} [title] Optional title for the attachment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveySettingsAttachmentsSurveyUuidPost_4(surveyUuid: string, attachment: File, title?: string, options?: RawAxiosRequestConfig) {
        return PerSurveyExportSettingsApiFp(this.configuration).apiV1SurveySettingsAttachmentsSurveyUuidPost_4(surveyUuid, attachment, title, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns survey export settings. Uses global settings if no custom version exists.
     * @summary Get survey-specific export settings
     * @param {string} surveyUuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveySettingsGeneralSurveyUuidGet(surveyUuid: string, options?: RawAxiosRequestConfig) {
        return PerSurveyExportSettingsApiFp(this.configuration).apiV1SurveySettingsGeneralSurveyUuidGet(surveyUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns survey export settings. Uses global settings if no custom version exists.
     * @summary Get survey-specific export settings
     * @param {string} surveyUuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveySettingsGeneralSurveyUuidGet_5(surveyUuid: string, options?: RawAxiosRequestConfig) {
        return PerSurveyExportSettingsApiFp(this.configuration).apiV1SurveySettingsGeneralSurveyUuidGet_5(surveyUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates survey export settings. Clones global settings on first edit. The reportLanguage field is a per-survey override stored on the survey itself: null = leave unchanged, empty string = clear the override back to inherit, non-empty = set the override. When the PATCH changes the effective report language and the survey already has its own cloned version, its six report text fields are automatically reset to the owner global baseline for the new language (text values sent in the same PATCH win). A survey still sharing the global version is NOT cloned by a language-only PATCH — it keeps following global settings and its texts switch language automatically via the global per-language rows.
     * @summary Update survey-specific export settings
     * @param {string} surveyUuid Survey UUID
     * @param {ApiV1SurveySettingsGeneralSurveyUuidPatchRequest} [apiV1SurveySettingsGeneralSurveyUuidPatchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveySettingsGeneralSurveyUuidPatch(surveyUuid: string, apiV1SurveySettingsGeneralSurveyUuidPatchRequest?: ApiV1SurveySettingsGeneralSurveyUuidPatchRequest, options?: RawAxiosRequestConfig) {
        return PerSurveyExportSettingsApiFp(this.configuration).apiV1SurveySettingsGeneralSurveyUuidPatch(surveyUuid, apiV1SurveySettingsGeneralSurveyUuidPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates survey export settings. Clones global settings on first edit. The reportLanguage field is a per-survey override stored on the survey itself: null = leave unchanged, empty string = clear the override back to inherit, non-empty = set the override. When the PATCH changes the effective report language and the survey already has its own cloned version, its six report text fields are automatically reset to the owner global baseline for the new language (text values sent in the same PATCH win). A survey still sharing the global version is NOT cloned by a language-only PATCH — it keeps following global settings and its texts switch language automatically via the global per-language rows.
     * @summary Update survey-specific export settings
     * @param {string} surveyUuid Survey UUID
     * @param {ApiV1SurveySettingsGeneralSurveyUuidPatchRequest} [apiV1SurveySettingsGeneralSurveyUuidPatchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveySettingsGeneralSurveyUuidPatch_6(surveyUuid: string, apiV1SurveySettingsGeneralSurveyUuidPatchRequest?: ApiV1SurveySettingsGeneralSurveyUuidPatchRequest, options?: RawAxiosRequestConfig) {
        return PerSurveyExportSettingsApiFp(this.configuration).apiV1SurveySettingsGeneralSurveyUuidPatch_6(surveyUuid, apiV1SurveySettingsGeneralSurveyUuidPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

